import { z, ZodType, ZodTypeDef } from 'zod/v3';
import { isIsoDateTime, ISODateTime } from '../dateUtils';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './zIsoDateTime.translations.json';

const { addTranslations, t } = i18nNsFactory('iso-date');
addTranslations(translations);

export const zIsoDateTime = (
  messageFn?: () => string | undefined,
): ZodType<ISODateTime, ZodTypeDef, ISODateTime> =>
  z.custom<ISODateTime>(isIsoDateTime, () => ({
    message: messageFn?.() || t('iso-date-time'),
  }));
